export class Outlay {
    pk: number;
    lang: string;
    created_at: string;
    //pk_client: number;
    //pk_campania: number;
    element: string;
    phone_type: string;
    call_price_type: string;
    status: string;
    response: string;
    //timezone: string;
    //dialedtime: number;
    call_provider: string;
    call_time: number;
    redir_time: number;
    talking_time: number;
    total_time: number;
    call_price: number;
    call_outlay: number;

    constructor(row: Object) {
        this.pk = row['pk'];
        this.lang = row['lang'];
        this.created_at = row['created_at'];
        //this.pk_client = row['pk_client'];
        //this.pk_campania = row['pk_campania'];
        this.element = row['element'];
        this.phone_type = row['phone_type'];
        this.call_price_type = row['call_price_type'];
        this.status = row['status'];
        this.response = row['response'];
        //this.timezone = row['timezone'];
        //this.dialedtime = row['dialedtime'];
        this.call_provider = row['service_provider_name'];
        this.call_time = row['call_time'];
        this.redir_time = row['redir_time'];
        this.talking_time = row['talking_time'];
        this.total_time = row['total_time'];
        this.call_price = row['call_price'];
        this.call_outlay = row['call_outlay'];
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/outlay/model/outlay.ts